import { render } from "./RoundedPillBadges.vue?vue&type=template&id=6f121282&ts=true"
import script from "./RoundedPillBadges.vue?vue&type=script&lang=ts"
export * from "./RoundedPillBadges.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__